<div class="appContentsContainer">
  <form
    [formGroup]="printsRules"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm wrapHalfRows editReglasImpresion"
  >
    <div class="collapseButtonContainer">
      <div class="pageTitle collapsibleTitle">
        <div class="pageTitle" *ngIf="operation === 'creacion'">
          {{ "printsRules.titleCreate" | translate }}
        </div>
        <div class="pageTitle" *ngIf="operation === 'edicion'">
          {{ "printsRules.titleEdit" | translate }}
        </div>
      </div>
    </div>

    <div class="row compressedRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="tetiqueta">Tipo de etiqueta</label>
          </div>
        </div>
        <div class="inputContainer">
          <app-input-selector-with-search
            *ngIf="listValuesEtiqueta.length > 0"
            [list]="listValuesEtiqueta"
            [fields]="['tpNombre']"
            [id]="'tpTipo'"
            [item]="printsRules.value.tetiqueta"
            (sendValue)="valueSelector($event)"
          ></app-input-selector-with-search>
          <div class="supIndex">*</div>
        </div>
      </div>
    </div>

    <div class="row compressedRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="riTipoEtiqueta">Tipo de placa</label>
          </div>
        </div>
        <div class="inputContainer">
          <app-input-selector-with-search
            *ngIf="listValuesFabricantes.length > 0"
            [list]="listValuesFabricantes"
            [fields]="['TipoPlaca']"
            [id]="'ValorPlaca'"
            [item]="printsRules.value.riTipoEtiqueta"
            (sendValue)="valueSelector($event)"
          ></app-input-selector-with-search>
          <div class="supIndex">*</div>
        </div>
      </div>
    </div>

    <div class="row compressedRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="riMarca">Marca</label>
          </div>
        </div>
        <div class="inputContainer">
          <app-input-selector-with-search
            *ngIf="listValuesMarcas.length > 0"
            [list]="listValuesMarcas"
            [fields]="['maId', 'maDescr']"
            [id]="'maId'"
            [item]="printsRules.value.riMarca"
            (sendValue)="valueSelector($event)"
          ></app-input-selector-with-search>
          <div class="supIndex">*</div>
        </div>
      </div>
    </div>

    <div class="row compressedRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="riTipoHomologado">Tipo homologado</label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            type="text"
            formControlName="riTipoHomologado"
            maxlength="27"
          />
          <div class="supIndex">*</div>
        </div>
      </div>
    </div>

    <div class="row compressedRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="formatosimpresion">Formato de impresión</label>
          </div>
        </div>
        <div class="inputContainer">
          <app-input-selector-with-search
            *ngIf="listValuesFormatosImpresion.length > 0"
            [list]="listValuesFormatosImpresion"
            [fields]="['fiId', 'fiDesc']"
            [id]="'fiId'"
            [item]="printsRules.value.formatosimpresion"
            (sendValue)="valueSelector($event)"
          ></app-input-selector-with-search>
          <div class="supIndex">*</div>
        </div>
      </div>
    </div>

    <div class="formGroupButtons detalleFormGroupButtonsFooter">
      <div class="formButton" *ngIf="printsRules.pristine">
        <button class="submitButton" (click)="goList()">
          <em class="fas fa-caret-square-left"></em>
        </button>
      </div>

      <div class="formButton" *ngIf="!printsRules.pristine">
        <button class="submitButton" [swal]="confirmSwal">
          <em class="fas fa-caret-square-left"></em>
        </button>
      </div>

      <div class="formButton middleButtonAceptarContainer">
        <div class="middleButtonAceptar formButton">
          <button type="submit" class="submitButton">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>

    <swal
      #confirmSwal
      html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
      icon="warning"
      [showCancelButton]="true"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
      [focusCancel]="true"
      (confirm)="goList()"
    >
    </swal>
  </form>
</div>
